import { buildAction } from "../util/util";

// generic function to reset state in Redux
export function resetState(type, payload) {
    return (dispatch) => {
        dispatch(buildAction(type, payload));
    };
}